import React from 'react'

import { Box, Stack, Typography } from '@mui/material'

const DisplayModeTooltip: React.FC = () => {
  return (
    <Stack direction="row" gap={3} p={1}>
      {/* Modo Lista */}
      <Stack alignItems="center" gap={1}>
        <Typography variant="xsBold" color="white">
          Lista
        </Typography>
        <svg width="120" height="80" viewBox="0 0 120 80">
          {[0, 1, 2, 3].map((i) => (
            <g key={i} transform={`translate(0, ${i * 20})`}>
              <rect
                x="4"
                y="2"
                width="14"
                height="14"
                rx="3"
                fill="none"
                stroke="#fff"
                strokeWidth="1.5"
              />
              {i === 1 && (
                <polyline
                  points="7,9 10,12 15,5"
                  fill="none"
                  stroke="#fff"
                  strokeWidth="1.5"
                />
              )}
              <text x="24" y="13" fill="#fff" fontSize="10">
                {`Opção ${i + 1}`}
              </text>
            </g>
          ))}
        </svg>
      </Stack>

      {/* Divisor */}
      <Box
        sx={{
          width: '1px',
          backgroundColor: 'rgba(255,255,255,0.3)',
          alignSelf: 'stretch'
        }}
      />

      {/* Modo Lista Suspensa */}
      <Stack alignItems="center" gap={1}>
        <Typography variant="xsBold" color="white">
          Lista suspensa
        </Typography>
        <svg width="120" height="80" viewBox="0 0 120 80">
          {/* Input fechado */}
          <rect
            x="4"
            y="2"
            width="112"
            height="24"
            rx="4"
            fill="none"
            stroke="#fff"
            strokeWidth="1.5"
          />
          <text x="10" y="18" fill="rgba(255,255,255,0.6)" fontSize="9">
            Selecione...
          </text>
          {/* Chevron */}
          <polyline
            points="100,11 106,16 112,11"
            fill="none"
            stroke="#fff"
            strokeWidth="1.5"
          />
          {/* Dropdown aberto */}
          <rect
            x="4"
            y="30"
            width="112"
            height="48"
            rx="4"
            fill="rgba(255,255,255,0.1)"
            stroke="#fff"
            strokeWidth="1"
          />
          {[0, 1, 2].map((i) => (
            <g key={i} transform={`translate(0, ${30 + i * 16})`}>
              <rect
                x="8"
                y="2"
                width="10"
                height="10"
                rx="2"
                fill="none"
                stroke="#fff"
                strokeWidth="1"
              />
              {i === 0 && (
                <polyline
                  points="10,7 12,9 16,4"
                  fill="none"
                  stroke="#fff"
                  strokeWidth="1"
                />
              )}
              <text x="22" y="11" fill="#fff" fontSize="8">
                {`Opção ${i + 1}`}
              </text>
            </g>
          ))}
        </svg>
      </Stack>
    </Stack>
  )
}

export default DisplayModeTooltip
